import { render } from "./doughnutChartHouseHoldProb.vue?vue&type=template&id=4dd4090e&scoped=true"
import script from "./doughnutChartHouseHoldProb.vue?vue&type=script&lang=js"
export * from "./doughnutChartHouseHoldProb.vue?vue&type=script&lang=js"

import "./doughnutChartHouseHoldProb.vue?vue&type=style&index=0&id=4dd4090e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd4090e"]])

export default __exports__